const getters = {};

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/calendar/getters.js